import { render, staticRenderFns } from "./DetailsLeads.vue?vue&type=template&id=2b5a7fac&"
import script from "./DetailsLeads.vue?vue&type=script&lang=js&"
export * from "./DetailsLeads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports